(function () {


    angular.module('app.widgets').directive("plaOwlCarousel", function() {
        return {
            restrict: 'E',
            transclude: false,
            link: function (scope, element) {
                scope.initCarousel = function(element) {
                  // provide any default options you want
                    var defaultOptions = {
                    };
                    var customOptions = scope.$eval($(element).attr('data-plugin-options'));
                    // combine the two options objects
                    for(var key in customOptions) {
                        defaultOptions[key] = customOptions[key];
                    }
                    // init carousel
                    $(element).owlCarousel(defaultOptions);
                };

                scope.initCarousel(element);
            }
        };
    });

})();